export function checkTimeLimit(time?: string, limitMinutes?: number) {
  if (!time || !limitMinutes) return false;

  const date = new Date(time);
  const currentTime = new Date();

  return currentTime.getTime() <= date.getTime() + limitMinutes * 60 * 1000;
}
